import { z } from "zod";

export const validateVehicleRestitutionPayload = z.object({
  restitution: z.uuid(),
  validatedBy: z.uuid(),
});

export type ValidateVehicleRestitutionPayload = z.infer<
  typeof validateVehicleRestitutionPayload
>;
